var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersPreviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 99,
    viewBox: "0 0 110 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -6.9,
    y: 8.68984,
    width: 110.859,
    height: 96.9211
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(3.45px)",
      clipPath: "url(#bgblur_0_10040_59015_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 6.9,
    d: "M15.1628 16.0895H35.4157L27.9818 50.2991L27.85 50.9053H28.4704H42.0066V98.2109H0.499771V50.5073L15.1628 16.0895ZM69.7149 16.0895H89.7721L82.5332 50.3018L82.4055 50.9053H83.0224H96.5586V98.2109H55.0518V50.5073L69.7149 16.0895Z",
    fill: "#23262F",
    fillOpacity: 0.6,
    stroke: "#353945"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 0.941406,
    y: -11.2891,
    width: 121.059,
    height: 107.121
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6px)",
      clipPath: "url(#bgblur_1_10040_59015_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 12,
    d: "M28.1042 1.21057H48.3571L40.9232 35.4202L40.7915 36.0264H41.4118H54.948V83.332H13.4412V35.6284L28.1042 1.21057ZM82.6563 1.21057H102.713L95.4746 35.4229L95.3469 36.0264H95.9638H109.5V83.332H67.9932V35.6284L82.6563 1.21057Z",
    stroke: "#5834A8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_10040_59015_clip_path",
    transform: "translate(6.9 -8.68984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1628 16.0895H35.4157L27.9818 50.2991L27.85 50.9053H28.4704H42.0066V98.2109H0.499771V50.5073L15.1628 16.0895ZM69.7149 16.0895H89.7721L82.5332 50.3018L82.4055 50.9053H83.0224H96.5586V98.2109H55.0518V50.5073L69.7149 16.0895Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_10040_59015_clip_path",
    transform: "translate(-0.941406 11.2891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1042 1.21057H48.3571L40.9232 35.4202L40.7915 36.0264H41.4118H54.948V83.332H13.4412V35.6284L28.1042 1.21057ZM82.6563 1.21057H102.713L95.4746 35.4229L95.3469 36.0264H95.9638H109.5V83.332H67.9932V35.6284L82.6563 1.21057Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersPreviewIcon);
export default __webpack_public_path__ + "static/media/users_preview_icon.0d76c6f83db22e1b20475b6a28902f9d.svg";
export { ForwardRef as ReactComponent };